import sanitizeHtml from 'sanitize-html';

export const clearHtml = (text) =>
  sanitizeHtml(`${text || ''}`, {
    allowedTags: [
      'div',
      'br',
      'b',
      'i',
      'strong',
      'del',
      'ol',
      'ul',
      'li',
      'h1',
      'blockquote',
    ],
  });

export const allClearHtml = (text) =>
  sanitizeHtml(`${text || ''}`, {
    allowedTags: [],
  });
